import { Link } from 'react-router-dom';

export default function Footer() {
  return (
    <footer className="bg-gray-900 text-white">
      <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8 py-12">
        <div className="grid grid-cols-1 md:grid-cols-4 gap-8">
          {/* Company Info */}
          <div className="col-span-1 md:col-span-2">
            <img 
              src="https://static.readdy.ai/image/7d31b8045d80057b2b2209dba23a3f63/d6f2ccdac6f77d2976c5910b8b505f63.png" 
              alt="LION URBAN Logo" 
              className="h-12 w-auto mb-4"
            />
            <p className="text-gray-300 mb-4">
              Tu marca merece verse bien.
              Nosotros la llevamos al siguiente nivel con impresión de alto impacto y diseño con actitud.
            </p>
            <div className="flex space-x-4">
              <a href="https://www.facebook.com/share/19gJu4pUHt/" target="_blank" rel="noopener noreferrer" className="text-gray-300 hover:text-green-400 transition-colors duration-200 cursor-pointer">
                <i className="ri-facebook-fill text-xl"></i>
              </a>
              <a href="https://www.instagram.com/lionurbandesignprint?igsh=MXJkYjFtZjRuM2FpdA==" target="_blank" rel="noopener noreferrer" className="text-gray-300 hover:text-green-400 transition-colors duration-200 cursor-pointer">
                <i className="ri-instagram-fill text-xl"></i>
              </a>
              <a href="https://www.tiktok.com/@lionurbandesignprint?_t=ZS-90Y5jfkYM1E&_r=1" target="_blank" rel="noopener noreferrer" className="text-gray-300 hover:text-green-400 transition-colors duration-200 cursor-pointer">
                <i className="ri-tiktok-fill text-xl"></i>
              </a>
            </div>
          </div>

          {/* Quick Links */}
          <div>
            <h3 className="text-lg font-semibold mb-4">Enlaces Rápidos</h3>
            <ul className="space-y-2">
              <li>
                <Link to="/" onClick={() => window.scrollTo(0, 0)} className="text-gray-300 hover:text-green-400 transition-colors duration-200 cursor-pointer">
                  Inicio
                </Link>
              </li>
              <li>
                <Link to="/about" onClick={() => window.scrollTo(0, 0)} className="text-gray-300 hover:text-green-400 transition-colors duration-200 cursor-pointer">
                  Acerca de Nosotros
                </Link>
              </li>
              <li>
                <Link to="/products" onClick={() => window.scrollTo(0, 0)} className="text-gray-300 hover:text-green-400 transition-colors duration-200 cursor-pointer">
                  Productos y Servicios
                </Link>
              </li>
              <li>
                <Link to="/contact" onClick={() => window.scrollTo(0, 0)} className="text-gray-300 hover:text-green-400 transition-colors duration-200 cursor-pointer">
                  Contacto
                </Link>
              </li>
            </ul>
          </div>

          {/* Contact Info */}
          <div>
            <h3 className="text-lg font-semibold mb-4">Contacto</h3>
            <div className="space-y-2 text-gray-300">
              <div className="flex items-center flex-wrap gap-2">
                <i className="ri-phone-fill mr-2"></i>
                <a 
                  href="https://wa.me/573209769166?text=Hola, me interesa conocer más sobre sus servicios de publicidad e impresión"
                  target="_blank"
                  rel="noopener noreferrer"
                  className="hover:text-green-400 transition-colors duration-200 cursor-pointer"
                >
                  320 976 9166
                </a>
                <span className="text-gray-500">|</span>
                <a 
                  href="https://wa.me/message/GG6UNVA6HN5UG1"
                  target="_blank"
                  rel="noopener noreferrer"
                  className="hover:text-green-400 transition-colors duration-200 cursor-pointer"
                >
                  321 618 8801
                </a>
              </div>
              <div className="flex items-center">
                <i className="ri-mail-fill mr-2"></i>
                <span>lionurbandesignprint@gmail.com</span>
              </div>
              <div className="flex items-center">
                <i className="ri-map-pin-fill mr-2"></i>
                <span>Bogotá</span>
              </div>
            </div>
          </div>
        </div>

        <div className="border-t border-gray-800 mt-8 pt-8 text-center text-gray-400">
          <p>&copy; 2024 LION URBAN. Todos los derechos reservados. | Diseñado por Lion Urban Design Print</p>
        </div>
      </div>
    </footer>
  );
}
